export const CourseStateList = ['ACTIVE', 'COMPLETED', 'ARCHIVED'];

export type CourseState = typeof CourseStateList[number];

export const ResourcesType = ['FILE', 'LINK'];

export type ResourcesType = typeof ResourcesType[number];
